export const SEARCH_CHANGE = 'SEARCH_CHANGE'
export const CHANGE_SELECTED = 'CHANGE_SELECTED'
export const SWITCH_UNIVERSE = 'SWITCH_UNIVERSE'
export const ADD_NEW_HERO = 'ADD_NEW_HERO'
export const INCREASE_HERO_COUNTER = 'INCREASE_HERO_COUNTER'
export const DECREASE_HERO_COUNTER = 'DECREASE_HERO_COUNTER'
export const DELETE_SELECTED_HERO = 'DELETE_SELECTED_HERO'

